// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  background-color: transparent;
  transition: background-color 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.overlay.visible {
  width: 1920px;
  height: 100%;
  position: absolute;
  top: 0;
  opacity: 0.75;
  background-color: #000000;
  z-index: 30;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/overlay/overlay.component.less"],"names":[],"mappings":"AAEA;EACI,6BAAA;EACA,qEAAA;AADJ;AAGI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;AADR","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.overlay {\n    background-color: transparent;\n    transition: background-color .2s cubic-bezier(.215,.61,.355,1);\n\n    &.visible {\n        width: 1920px;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        opacity: 0.75;\n        background-color: @black;\n        z-index: 30;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
